import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/feature/SEOHead';
import Hero from './components/Hero';
import StatsSection from './components/StatsSection';
import ProductShowcase from './components/ProductShowcase';
import BrandFeatures from './components/BrandFeatures';
import Testimonials from './components/Testimonials';
import FAQ from './components/FAQ';
import NewsSection from './components/NewsSection';
import { faqData } from '@/mocks/homeData';
import { getOrganizationSchema, getWebSiteSchema, getWebPageSchema, getFAQSchema } from '@/utils/schemas';

export default function Home() {
  const homeTitle = '惠美梨——品质优选，甜蜜直达你的餐桌 | 惠美梨产地直供';
  const homeDesc = '惠美梨，精选优质梨果，皮薄汁多、清甜爽口，产地直供保障新鲜品质。提供翠冠梨、黄花梨、丰水梨、雪花梨等多品种新鲜梨果礼盒，是日常鲜食与礼品馈赠的首选。了解惠美梨品种特色、产地溯源与购买方式。';

  const schemas = [
    getOrganizationSchema(),
    getWebSiteSchema(),
    getWebPageSchema('惠美梨首页 - 品质优选', homeDesc, 'https://hwsxsp.cn/'),
    getFAQSchema(faqData),
  ];

  return (
    <>
      <SEOHead
        title={homeTitle}
        description={homeDesc}
        canonicalUrl="https://hwsxsp.cn/"
        schema={schemas}
      />
      <Navbar />
      <main>
        <Hero />
        <StatsSection />
        <ProductShowcase />
        <BrandFeatures />
        <Testimonials />
        <FAQ />
        <NewsSection />
      </main>
      <Footer />
    </>
  );
}